import { Input } from "@brg/input";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core/modules/layout.module";
import styled from "styled-components";

export const CustomDropdown = styled(Input.Dropdown)`
  .brg-input__control {
    height: 20px !important;
    width: ${p => p.lang === 'en' ? '219px' : '250px'} !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    padding-left: 8px;
    cursor: pointer;
  }
    
  .brg-input__value-container{
    height: 100% !important;
    margin-top: -3px;
  }

  .brg-input__control:hover svg {
    fill:  #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__placeholder{
    color: #FEFEFE !important;
    font-weight: 600;
    white-space: nowrap;
  },

  .brg-input__placeholder:hover{
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

 .brg-input__menu {
    width: 250px;
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    padding: 8px 12px;
  }

  .brg-input__indicator {
    width: auto;
    height: 34px;
  }

  .brg-input__dropdown-indicator svg path{
    fill: #fefefe !important;
  }

.brg-input__dropdown-indicator{
    opacity: 1;
    margin-right: 14px;
    padding: 8px 8px 8px 10px;
  }

  .brg-input__control:hover svg { fill: #FEFEFE !important; }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .brg-input__control {
      margin: 0 17px;
    }
      
    .brg-input__menu{
      margin-left: 17px;
    }
  }
`;import { Input } from "@brg/input";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core/modules/layout.module";
import styled from "styled-components";

export const CustomDropdown = styled(Input.Dropdown)`
  .brg-input__control {
    height: 20px !important;
    width: ${p => p.lang === 'en' ? '219px' : '250px'} !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    padding-left: 8px;
    cursor: pointer;
  }
    
  .brg-input__value-container{
    height: 100% !important;
    margin-top: -3px;
  }

  .brg-input__control:hover svg {
    fill:  #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__placeholder{
    color: #FEFEFE !important;
    font-weight: 600;
    white-space: nowrap;
  },

  .brg-input__placeholder:hover{
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

 .brg-input__menu {
    width: 250px;
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    padding: 8px 12px;
  }

  .brg-input__indicator {
    width: auto;
    height: 34px;
  }

  .brg-input__dropdown-indicator svg path{
    fill: #fefefe !important;
  }

.brg-input__dropdown-indicator{
    opacity: 1;
    margin-right: 14px;
    padding: 8px 8px 8px 10px;
  }

  .brg-input__control:hover svg { fill: #FEFEFE !important; }

  @media (max-width: ${LayoutConst.screen.l}px) {
    .brg-input__control {
      margin: 0 17px;
    }
      
    .brg-input__menu{
      margin-left: 17px;
    }
  }
`;